import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { db } from '../firebaseConfig';
import { doc, getDoc, updateDoc, deleteDoc } from 'firebase/firestore';
import { IoArrowBack, IoTrash, IoSave, IoInformationCircleOutline } from 'react-icons/io5';
import './EditarVisitaScreen.css'; // --- Premium CSS ---

function EditarVisitaScreen() {
  const navigate = useNavigate();
  const { visitaId } = useParams();
  const [loading, setLoading] = useState(true);
  const [enviando, setEnviando] = useState(false);

  const [parentesco, setParentesco] = useState('');
  const [nombres, setNombres] = useState('');
  const [apellidos, setApellidos] = useState('');

  // Cargar datos
  useEffect(() => {
    const cargarDatos = async () => {
      const docRef = doc(db, "visitasRecurrentes", visitaId);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        setParentesco(data.parentesco);
        setNombres(data.nombres || ''); // Fallback
        setApellidos(data.apellidos || ''); // Fallback
        setLoading(false);
      } else {
        alert("Error: No se encontró la visita.");
        navigate('/accesos/visitas');
      }
    };
    cargarDatos();
  }, [visitaId, navigate]);

  // Actualizar datos
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!parentesco || !nombres || !apellidos) {
      alert('Todos los campos son obligatorios.');
      return;
    }
    setEnviando(true);

    try {
      const docRef = doc(db, "visitasRecurrentes", visitaId);
      await updateDoc(docRef, {
        parentesco: parentesco,
        nombres: nombres,
        apellidos: apellidos,
        nombreCompleto: `${nombres} ${apellidos}`,
      });

      alert('¡Visita actualizada!');
      navigate('/accesos/visitas');

    } catch (error) {
      console.error("Error al actualizar visita: ", error);
      alert('Error al actualizar la visita.');
    } finally {
      setEnviando(false);
    }
  };

  // Borrar
  const handleDelete = async () => {
    if (window.confirm('¿Estás seguro de que quieres borrar esta visita recurrente?')) {
      setEnviando(true);
      try {
        const docRef = doc(db, "visitasRecurrentes", visitaId);
        await deleteDoc(docRef);
        alert('Visita recurrente borrada.');
        navigate('/accesos/visitas');
      } catch (error) {
        console.error("Error al borrar visita: ", error);
        alert('Error al borrar la visita.');
      } finally {
        setEnviando(false);
      }
    }
  };

  if (loading) {
    return <div className="edit-visita-container"><p>Cargando datos...</p></div>;
  }

  return (
    <div className="edit-visita-container">
      <div className="edit-visita-header">
        <button onClick={() => navigate('/accesos/visitas')} className="edit-back-btn">
          <IoArrowBack />
        </button>
        <h1 className="edit-title">Editar Visita</h1>
      </div>

      <div className="edit-visita-card">
        <div className="visita-status-widget">
          <div className="status-icon-box"><IoInformationCircleOutline size={28} /></div>
          <div className="status-info">
            <h4>Detalle de la Visita</h4>
            <p>Edita los datos de tu visita recurrente. Estos cambios se reflejarán en sus próximos accesos.</p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="edit-visita-grid">
          <div className="form-field full-width">
            <label className="field-label">Parentesco / Relación</label>
            <select value={parentesco} onChange={(e) => setParentesco(e.target.value)} className="field-select" required>
              <option value="">Selecciona una opción...</option>
              <option value="Familiar">Familiar</option>
              <option value="Amistad">Amistad</option>
              <option value="Servicio">Servicio / Trabajador</option>
              <option value="Otro">Otro</option>
            </select>
          </div>

          <div className="form-field">
            <label className="field-label">Nombre(s)</label>
            <input type="text" value={nombres} onChange={(e) => setNombres(e.target.value)} className="field-input" placeholder="Ej. Juan" required />
          </div>

          <div className="form-field">
            <label className="field-label">Apellidos</label>
            <input type="text" value={apellidos} onChange={(e) => setApellidos(e.target.value)} className="field-input" placeholder="Ej. Pérez" required />
          </div>

          <div className="action-bar">
            <button type="submit" className="btn-save" disabled={enviando}>
              <IoSave size={20} />
              {enviando ? 'Guardando...' : 'Guardar Cambios'}
            </button>
            <button type="button" className="btn-delete" onClick={handleDelete} disabled={enviando}>
              <IoTrash size={20} />
              Borrar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditarVisitaScreen;